import LoaderView from './LoaderView';
import './Loader.css';

export default LoaderView;
